{
    "yvcWLLwGesAo-CI9CHg4N": {
        "key": "yvcWLLwGesAo-CI9CHg4N",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "WeXLbGJU8jO8CW4GhhVw0": {
        "key": "WeXLbGJU8jO8CW4GhhVw0",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "_bxSmy3RIeZJj9ZzX0iT2": {
        "key": "_bxSmy3RIeZJj9ZzX0iT2",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "vK84aULEtgXf1Ixzr-3yK": {
        "key": "vK84aULEtgXf1Ixzr-3yK",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "ioDRp_mgh00fbOeAaYd8K": {
        "key": "ioDRp_mgh00fbOeAaYd8K",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "iyJJrxX_VOKBhArWKfpwY": {
        "key": "iyJJrxX_VOKBhArWKfpwY",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "dLj4uhtYnrZZO4hlQdCm-": {
        "key": "dLj4uhtYnrZZO4hlQdCm-",
        "isDead": false,
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "zuE5CJ1C4ePx-4MXoLO0k": {
        "key": "zuE5CJ1C4ePx-4MXoLO0k",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "H9B1A8p7Y7hHcaz6HqdfZ": {
        "key": "H9B1A8p7Y7hHcaz6HqdfZ",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "pdKhOJjUgqpH0lJM0LzUt": {
        "key": "pdKhOJjUgqpH0lJM0LzUt",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 20,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "spear",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "Bj7E1sFcVGqnH6cgF-GQl": {
        "key": "Bj7E1sFcVGqnH6cgF-GQl",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "spear",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "jBqlLeugzamHKmMNY-Dt6": {
        "key": "jBqlLeugzamHKmMNY-Dt6",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 17,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "spear",
        "maxhealth": "30",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "7pRNomMPJnv1tbT6cQBMo": {
        "key": "7pRNomMPJnv1tbT6cQBMo",
        "isDead": false,
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "spear",
        "maxhealth": 30,
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "9r2D70g30H6ryS2-saqpO": {
        "key": "9r2D70g30H6ryS2-saqpO",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 15,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "E7ISLQQfyTKgDCxBlA16B": {
        "key": "E7ISLQQfyTKgDCxBlA16B",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "spearknight",
        "maxhealth": 50,
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "x2Bw2x_c6Mqt8YA5vbV8B": {
        "key": "x2Bw2x_c6Mqt8YA5vbV8B",
        "isDead": false,
        "position": {
            "x": 11,
            "y": 13,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "hammer",
        "maxhealth": "30",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "yEZUjuSmJvuNmFmpB7039": {
        "key": "yEZUjuSmJvuNmFmpB7039",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 11,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "hammer",
        "maxhealth": "30",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "SvoPZMFptpGt1R2S8myM9": {
        "key": "SvoPZMFptpGt1R2S8myM9",
        "isDead": false,
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "hammer",
        "maxhealth": "30",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "H05s05YpR45CD1W0Tcdji": {
        "key": "H05s05YpR45CD1W0Tcdji",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 7,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "59YtMmGPbKjxbSSRlmGeK": {
        "key": "59YtMmGPbKjxbSSRlmGeK",
        "isDead": false,
        "position": {
            "x": 18,
            "y": 9,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "DGKVnEC_cHilZYsOGA4ZB": {
        "key": "DGKVnEC_cHilZYsOGA4ZB",
        "isDead": false,
        "position": {
            "x": 11,
            "y": 7,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "jobKey": "bow",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "QJo6sa-PIVsONZoNr_Zav": {
        "key": "QJo6sa-PIVsONZoNr_Zav",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 16,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "jobKey": "hammercavalier",
        "maxhealth": "50",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "QNOKRM5D7P1EP8CaUeECj": {
        "key": "QNOKRM5D7P1EP8CaUeECj",
        "isDead": false,
        "position": {
            "x": 17,
            "y": 13,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "jobKey": "hammer",
        "maxhealth": "30",
        "effects": {},
        "inventory": {
            "items": {}
        }
    },
    "7_mA84BK6xYkKpEUPy6RR": {
        "key": "7_mA84BK6xYkKpEUPy6RR",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "wYF9Ql4y33cVUTRBYtHVy": {
        "key": "wYF9Ql4y33cVUTRBYtHVy",
        "isDead": false,
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    },
    "NoUmBiLcsDopfV_nJ88HR": {
        "key": "NoUmBiLcsDopfV_nJ88HR",
        "isDead": false,
        "position": {
            "x": 12,
            "y": 10,
            "z": 1
        },
        "affiliation": "none",
        "energy": {},
        "effects": {},
        "inventory": {
            "items": {}
        },
        "type": "spot"
    }
}